import { render, staticRenderFns } from "./PalletItemTable.vue?vue&type=template&id=00033882&scoped=true"
import script from "./PalletItemTable.vue?vue&type=script&lang=ts"
export * from "./PalletItemTable.vue?vue&type=script&lang=ts"
import style0 from "./PalletItemTable.vue?vue&type=style&index=0&id=00033882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00033882",
  null
  
)

export default component.exports